import { Footer } from '@scholastic/mockingjay';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import { useTrackPageView } from '@/hooks/use-track-page-view/use-track-page-view';
import { usePopulateDataLayer } from '@/hooks/use-populate-data-layer/use-populate-data-layer';

export function RootLayout() {
  usePopulateDataLayer();
  useTrackPageView();

  return (
    <div className="flex min-h-screen flex-col justify-between">
      <Outlet />
      <Footer showSiteMap showNewPrivacyPolicyLabel />
      <ScrollRestoration />
    </div>
  );
}
